import React from 'react'

function TechSelectionWFZ() {
  return (
    <embed src="\pdfs\E1.8_wfz_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionWFZ